var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAirImpact = function SvgAirImpact(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6632 5.04718C11.7723 4.85537 12.0493 4.85537 12.1584 5.04718L18.8818 16.866C18.9895 17.0555 18.8524 17.2904 18.6342 17.2904H11.1863C12.2083 16.766 12.9074 15.7033 12.9074 14.4777C12.9074 13.9528 12.7791 13.4577 12.5522 13.0221L12.5529 13.0216L12.282 12.5033H7.40642L7.7043 12.0061H12.0222L9.95496 8.0501L11.6632 5.04718Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57229 14.4777C6.57229 15.7033 7.2714 16.766 8.2934 17.2904H5.18748C4.96923 17.2904 4.83213 17.0555 4.93987 16.8661L6.62408 13.9054C6.59006 14.091 6.57229 14.2823 6.57229 14.4777Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAirImpact);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "AirImpact.040b23649d8822c996c93e00b38e97c7.svg";